// Thin API client for the ComplianceMinder MVP. All calls hit /api/compliance,
// which is 404 unless COMPLIANCEMINDER_ENABLED is set on the backend.
import axios from "axios";
import { API } from "../../../config/api";

const base = `${API}/compliance`;

export const CM_ENABLED = process.env.REACT_APP_COMPLIANCEMINDER_ENABLED === "true";

export const cmApi = {
  health: () => axios.get(`${base}/health`).then((r) => r.data),

  listPolicies: () => axios.get(`${base}/policies`).then((r) => r.data),
  getPolicy: (slug) => axios.get(`${base}/policies/${slug}`).then((r) => r.data),
  editLiveHead: (slug, markdown) =>
    axios.put(`${base}/policies/${slug}/live`, { markdown }).then((r) => r.data),
  approvePolicy: (slug, approved_by, change_note) =>
    axios.post(`${base}/policies/${slug}/approve`, { approved_by, change_note }).then((r) => r.data),

  listRegisters: () => axios.get(`${base}/registers`).then((r) => r.data),
  listEntries: (slug) => axios.get(`${base}/registers/${slug}/entries`).then((r) => r.data),
  addEntry: (slug, data) =>
    axios.post(`${base}/registers/${slug}/entries`, { data }).then((r) => r.data),

  listBundles: () => axios.get(`${base}/bundles`).then((r) => r.data),
  createBundle: (name, purpose, items) =>
    axios.post(`${base}/bundles`, { name, purpose, items }).then((r) => r.data),
  getBundle: (id) => axios.get(`${base}/bundles/${id}`).then((r) => r.data),
  addBundleItem: (id, item) =>
    axios.post(`${base}/bundles/${id}/items`, item).then((r) => r.data),
  exportBundle: (id) => axios.post(`${base}/bundles/${id}/export`).then((r) => r.data),

  // BM-H4201 ongoing competence log
  competenceMe: (year) =>
    axios.get(`${base}/competence/me`, { params: year ? { year } : {} }).then((r) => r.data),
  addCompetenceActivity: (activity) =>
    axios.post(`${base}/competence/activities`, activity).then((r) => r.data),
  deleteCompetenceActivity: (id) =>
    axios.delete(`${base}/competence/activities/${id}`).then((r) => r.data),
  setCompetenceRegulator: (regulator) =>
    axios.put(`${base}/competence/regulator`, { regulator }).then((r) => r.data),
};
